import { createSelector } from 'reselect';
import { FeaturesState } from 'common/features/featuresReducer';
import { MarketingUTMs, initialUTMsState, UTMsState, areUTMsExpired } from './duck';

const selectUTMsState = (state: FeaturesState): UTMsState => {
    if (!state || !state.store || !state.store.utms) {
        return initialUTMsState;
    }
    return state.store.utms;
};

export const selectMarketingUTMs = createSelector(
    [selectUTMsState],
    (utmsState: UTMsState): MarketingUTMs => {
        try {
            const marketingUTMs = utmsState?.marketingUTMs || {};

            if (utmsState?.capturedTimestamp !== undefined) {
                try {
                    const expired = areUTMsExpired(utmsState.capturedTimestamp);
                    if (expired) {
                        return {};
                    }
                } catch (error) {
                    return marketingUTMs;
                }
            }

            return marketingUTMs;
        } catch (error) {
            return {};
        }
    }
);

export const selectHasCapturedInitialUTMs = createSelector(
    [selectUTMsState],
    (utmsState: UTMsState): boolean => {
        return utmsState?.hasCapturedInitialUTMs || false;
    }
);

export const selectCapturedTimestamp = createSelector(
    [selectUTMsState],
    (utmsState: UTMsState): number | undefined => {
        return utmsState?.capturedTimestamp;
    }
);
